import React from "react";
import { Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { getLoginRedirectPath } from "./redux/common";

const PrivateRoute = ({ loggedIn, ...props }) => {
  return (
    <Route
      path={props.path}
      exact={props.exact}
      component={
        loggedIn
          ? props.component
          : () => <Redirect to={getLoginRedirectPath()} />
      }
    />
  );
};

const mapStateToProps = (state) => ({
  loggedIn: state.loggedIn,
});
const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(PrivateRoute);
